<style scoped>
  .index {
    width: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    text-align: center;
  }
  h1 {
    font-size: 20px;
  }
  h2{
    color: #AAA;
    font-size: 15px;
  }
  .index .ivu-row-flex {
    width: 100%;
  }
  .center{
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
  }
  .row {
    margin-top: 20px;
  }
</style>

<template>
  <div class="index">
      <div class="center">
        <Card style="padding: 10px 100px 20px 100px;border: 1px solid #dcdee2;box-shadow: 0 0 10px 10px #dcdee2">
          <div style="text-align: left">
            <Row class="row">
              <b style="font-size: 16px">您的IP地址 <span style="color: #DB7574">{{clientip}}</span> 已被阻止</b>
            </Row>
            <Row v-if="blockInfo !== ''" class="row">
              <b>(访问<span v-if="blockInfo.indexOf('urlGroup') === -1"> {{blockInfo}} </span>过于频繁)</b>
            </Row>
            <Row class="row">
              <b>请关闭代理服务或者关闭浏览器的云加速功能</b>
            </Row>
            <Row class="row">
              <span>请输入以下验证码解封</span>
            </Row>
            <Row type="flex" justify="center" align="middle" class="row">
              <img src="/getVerfiyCode" onclick="this.src='/getVerfiyCode?d='+Math.random();" />
            </Row>
            <Row type="flex" justify="center" align="middle" class="row">
              <Input v-model="vcode" placeholder="请输入验证码" style="width: 80%"/>
            </Row>
            <Row type="flex" justify="center" align="middle" class="row">
              <Button type="primary" @click="handleStart" >提交</Button>
            </Row>
          </div>
        </Card>
      </div>
    <Modal v-model="successModal" width="360">
      <p slot="header" style="color:#5bb75b;text-align:center">
        <Icon type="checkmark-circled"></Icon>
        <span>验证成功</span>
      </p>
      <div style="text-align:center">
        <p>您将在被 {{time}} 秒重定向到<a v-bind:href="refer">之前访问的页面</a></p>
      </div>
      <p slot="footer"></p>
    </Modal>
    <Modal v-model="errorModal" width="360" :closable="false" :mask-closable="false">
      <p slot="header" style="color:#ee5f5b;text-align:center">
        <Icon type="checkmark-circled"></Icon>
        <span>系统错误 !</span>
      </p>
      <div style="text-align:center">
        <p>无法获取UUID，请与管理员联系！</p>
      </div>
      <p slot="footer"></p>
    </Modal>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'index',
  data () {
    return {
      successModal: false,
      errorModal: false,
      blockInfo: '',
      vcode: '',
      refer: '',
      time: 3,
      clientip: ''
    }
  },
  methods: {
    redictUrl () {
      let me = this
      let interval = window.setInterval(function () {
        if ((me.time--) === 1) {
          window.clearInterval(interval)
          window.location.href = me.refer
        }
      }, 1000)
    },
    handleStart () {
      axios.post('/judgeVerfiyCode', {
        vcode: this.vcode,
        uuid: this.$route.query.uuid
      }).then(function (response) {
        if (response.data.flag === 'true') {
          this.redictUrl()
          this.successModal = true
        } else {
          this.$Modal.warning({
            title: '验证失败!',
            content: response.data.message,
            okText: '关闭'
          })
        }
      }.bind(this)).catch(function (error) {
        this.$Modal.info({title: '系统错误!', content: error.message, okText: '关闭'})
      }.bind(this))
    },
    getClientIp () {
      axios.get('/getClientIp').then(function (response) {
        this.clientip = response.data
        this.getBlockInfo()
        // eslint-disable-next-line handle-callback-err
      }.bind(this)).catch(function (error) {
        this.clientip = '(client error)'
      }.bind(this))
    },
    getBlockInfo () {
      axios.get('/getBlockInfo?ip=' + this.clientip).then(function (response) {
        this.blockInfo = response.data
        // eslint-disable-next-line handle-callback-err
      }.bind(this)).catch(function (error) {
        this.blockInfo = ''
      }.bind(this))
    }
  },
  mounted () {
    try {
      // eslint-disable-next-line no-use-before-define
      var _hmt = _hmt || []
      var hm = document.createElement('script')
      hm.src = 'https://hm.baidu.com/hm.js?78ccfca9e46fd5df531bd2a86d4f556c'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(hm, s)

      if (this.$route.query.uuid === undefined || this.$route.query.uuid.length !== 16) {
        this.errorModal = true
      } else {
        this.getClientIp()
        this.refer = 'http://' + window.atob(this.$route.query.referer)
      }
    } catch (e) {
      console.info(e)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/Index.vue